import React from "react";
import {
  AiOutlineArrowRight,
  AiOutlineClose,
  AiOutlineDownload,
  AiOutlinePlus,
  AiOutlineRollback,
  AiOutlineSave,
} from "react-icons/ai";
import { FaCheck, FaSearch, FaTimes, FaTrash } from "react-icons/fa";
import { GoPrimitiveDot } from "react-icons/go";
import { MdDelete, MdEdit } from "react-icons/md";
import { ImCancelCircle } from "react-icons/im";
import { InfoCircleFilled } from "@ant-design/icons";
import { GiExpand } from "react-icons/gi";

export const XIcon = (props) => (
  <AiOutlineClose
    color="#000000"
    className="text-sm cursor-pointer"
    {...props}
  />
);
export const IconDot = (props) => (
  <GoPrimitiveDot className="text-sm cursor-pointer" {...props} />
);
export const IconEdit = (props) => (
  <MdEdit color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);
export const IconDownload = (props) => (
  <AiOutlineDownload
    color="#C4C4C4"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconExclamation = (props) => (
  <InfoCircleFilled className="text-sm cursor-pointer" {...props} />
);

export const IconTag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    {...props}
  >
    <path
      d="M8.9375 11H1.375C1.01033 11 0.660591 10.8551 0.402728 10.5973C0.144866 10.3394 0 9.98967 0 9.625V2.0625C0 1.69783 0.144866 1.34809 0.402728 1.09023C0.660591 0.832366 1.01033 0.6875 1.375 0.6875H4.125V2.0625H1.375V9.625H8.9375V6.875H10.3125V9.625C10.3125 9.98967 10.1676 10.3394 9.90977 10.5973C9.65191 10.8551 9.30217 11 8.9375 11ZM5.29375 6.67356L4.32438 5.70144L8.65081 1.375H6.1875V0H11V4.8125H9.625V2.34781L5.29375 6.67356Z"
      fill="#F7931E"
    />
  </svg>
);

export const IconCopy = (props) => (
  <SvgCopy color="#fff" className="text-sm cursor-pointer" {...props} />
);
export const IconSearch = (props) => (
  <FaSearch color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);
export const IconTimes = (props) => (
  <FaTimes color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);
export const IconTrash = (props) => (
  <FaTrash color="#C4C4C4" className="text-sm cursor-pointer" {...props} />
);

export const IconRollBack = (props) => (
  <AiOutlineRollback
    color="#fff"
    className="text-sm cursor-pointer"
    {...props}
  />
);

export const IconArrowRight = (props) => (
  <AiOutlineArrowRight
    color="#D1D1D1"
    className="text-sm cursor-pointer"
    {...props}
  />
);

// custom
export const IconSave = (props) => (
  <AiOutlineSave fill="#C4C4C4" className="cursor-pointer text-sm" {...props} />
);

export const IconAccounting = (props) => (
  <SvgAccounting color="#fff" className="text-sm cursor-pointer" {...props} />
);

export const IconEraser = (props) => (
  <SvgEraser color="#fff" className="text-sm cursor-pointer" {...props} />
);
export const IconMessage = (props) => (
  <SvgMessage color="#fff" className="text-sm cursor-pointer" {...props} />
);
export const IconLoptop = (props) => (
  <SvgLoptop color="#fff" className="text-sm cursor-pointer" {...props} />
);

export const IconBarcode = (props) => (
  <SvgBarCode color="#fff" className="text-sm cursor-pointer" {...props} />
);
// CUSTOM SVGS

const SvgBarCode = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="#F7931E"
      {...props}
    >
      <path d="M2.36114 3.30556C2.2359 3.30556 2.11579 3.35531 2.02723 3.44387C1.93867 3.53243 1.88892 3.65254 1.88892 3.77778V14.1667C1.88892 14.2919 1.93867 14.412 2.02723 14.5006C2.11579 14.5891 2.2359 14.6389 2.36114 14.6389C2.48638 14.6389 2.60649 14.5891 2.69505 14.5006C2.78361 14.412 2.83336 14.2919 2.83336 14.1667V3.77778C2.83336 3.65254 2.78361 3.53243 2.69505 3.44387C2.60649 3.35531 2.48638 3.30556 2.36114 3.30556Z" />
      <path d="M4.25005 3.30556C4.12481 3.30556 4.0047 3.35531 3.91614 3.44387C3.82758 3.53243 3.77783 3.65254 3.77783 3.77778V12.2778C3.77783 12.403 3.82758 12.5231 3.91614 12.6117C4.0047 12.7003 4.12481 12.75 4.25005 12.75C4.3753 12.75 4.49541 12.7003 4.58397 12.6117C4.67252 12.5231 4.72228 12.403 4.72228 12.2778V3.77778C4.72228 3.65254 4.67252 3.53243 4.58397 3.44387C4.49541 3.35531 4.3753 3.30556 4.25005 3.30556Z" />
      <path d="M6.13897 3.30556C6.01373 3.30556 5.89362 3.35531 5.80506 3.44387C5.7165 3.53243 5.66675 3.65254 5.66675 3.77778V12.2778C5.66675 12.403 5.7165 12.5231 5.80506 12.6117C5.89362 12.7003 6.01373 12.75 6.13897 12.75C6.26421 12.75 6.38432 12.7003 6.47288 12.6117C6.56144 12.5231 6.61119 12.403 6.61119 12.2778V3.77778C6.61119 3.65254 6.56144 3.53243 6.47288 3.44387C6.38432 3.35531 6.26421 3.30556 6.13897 3.30556Z" />
      <path d="M8.02789 3.30556C7.90265 3.30556 7.78253 3.35531 7.69397 3.44387C7.60542 3.53243 7.55566 3.65254 7.55566 3.77778V12.2778C7.55566 12.403 7.60542 12.5231 7.69397 12.6117C7.78253 12.7003 7.90265 12.75 8.02789 12.75C8.15313 12.75 8.27324 12.7003 8.3618 12.6117C8.45036 12.5231 8.50011 12.403 8.50011 12.2778V3.77778C8.50011 3.65254 8.45036 3.53243 8.3618 3.44387C8.27324 3.35531 8.15313 3.30556 8.02789 3.30556Z" />
      <path d="M9.91656 3.30556C9.79132 3.30556 9.67121 3.35531 9.58265 3.44387C9.49409 3.53243 9.44434 3.65254 9.44434 3.77778V12.2778C9.44434 12.403 9.49409 12.5231 9.58265 12.6117C9.67121 12.7003 9.79132 12.75 9.91656 12.75C10.0418 12.75 10.1619 12.7003 10.2505 12.6117C10.339 12.5231 10.3888 12.403 10.3888 12.2778V3.77778C10.3888 3.65254 10.339 3.53243 10.2505 3.44387C10.1619 3.35531 10.0418 3.30556 9.91656 3.30556Z" />
      <path d="M11.8055 3.30556C11.6802 3.30556 11.5601 3.35531 11.4716 3.44387C11.383 3.53243 11.3333 3.65254 11.3333 3.77778V12.2778C11.3333 12.403 11.383 12.5231 11.4716 12.6117C11.5601 12.7003 11.6802 12.75 11.8055 12.75C11.9307 12.75 12.0508 12.7003 12.1394 12.6117C12.2279 12.5231 12.2777 12.403 12.2777 12.2778V3.77778C12.2777 3.65254 12.2279 3.53243 12.1394 3.44387C12.0508 3.35531 11.9307 3.30556 11.8055 3.30556Z" />
      <path d="M13.6944 3.30556C13.5691 3.30556 13.449 3.35531 13.3605 3.44387C13.2719 3.53243 13.2222 3.65254 13.2222 3.77778V12.2778C13.2222 12.403 13.2719 12.5231 13.3605 12.6117C13.449 12.7003 13.5691 12.75 13.6944 12.75C13.8196 12.75 13.9397 12.7003 14.0283 12.6117C14.1169 12.5231 14.1666 12.403 14.1666 12.2778V3.77778C14.1666 3.65254 14.1169 3.53243 14.0283 3.44387C13.9397 3.35531 13.8196 3.30556 13.6944 3.30556Z" />
      <path d="M15.5833 3.30556C15.4581 3.30556 15.338 3.35531 15.2494 3.44387C15.1608 3.53243 15.1111 3.65254 15.1111 3.77778V14.1667C15.1111 14.2919 15.1608 14.412 15.2494 14.5006C15.338 14.5891 15.4581 14.6389 15.5833 14.6389C15.7085 14.6389 15.8287 14.5891 15.9172 14.5006C16.0058 14.412 16.0555 14.2919 16.0555 14.1667V3.77778C16.0555 3.65254 16.0058 3.53243 15.9172 3.44387C15.8287 3.35531 15.7085 3.30556 15.5833 3.30556Z" />
    </svg>
  );
};
const SvgLoptop = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      {...props}
    >
      <path d="M9.6 22.88V10.6H24.4L25.98 9H8V22.88H9.6Z" fill="#F7931E" />
      <path
        d="M6 7H30V23H32V6.5C32 6.10218 31.842 5.72064 31.5607 5.43934C31.2794 5.15804 30.8978 5 30.5 5H5.5C5.10218 5 4.72064 5.15804 4.43934 5.43934C4.15804 5.72064 4 6.10218 4 6.5V23H6V7Z"
        fill="#F7931E"
      />
      <path
        d="M1 25V28.4C1 29.0896 1.27393 29.7509 1.76152 30.2385C2.24912 30.7261 2.91044 31 3.6 31H32.34C33.0296 31 33.6909 30.7261 34.1785 30.2385C34.6661 29.7509 34.94 29.0896 34.94 28.4V25H1ZM33 28.4C33 28.5591 32.9368 28.7117 32.8243 28.8243C32.7117 28.9368 32.5591 29 32.4 29H3.56C3.40087 29 3.24826 28.9368 3.13574 28.8243C3.02321 28.7117 2.96 28.5591 2.96 28.4V26.53H12.91C13.035 26.825 13.2437 27.0769 13.5103 27.2546C13.7768 27.4323 14.0896 27.5281 14.41 27.53H21.54C21.8604 27.5281 22.1732 27.4323 22.4397 27.2546C22.7063 27.0769 22.915 26.825 23.04 26.53H33V28.4Z"
        fill="#F7931E"
      />
    </svg>
  );
};

const SvgMessage = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      {...props}
    >
      <path
        d="M13.1667 0.416672H1.83341C1.05212 0.416672 0.416748 1.05205 0.416748 1.83334V14.5833L3.25008 11.75H13.1667C13.948 11.75 14.5834 11.1146 14.5834 10.3333V1.83334C14.5834 1.05205 13.948 0.416672 13.1667 0.416672ZM5.37508 7.50001C5.189 7.49996 5.00474 7.46326 4.83284 7.39201C4.66093 7.32075 4.50475 7.21633 4.3732 7.08472C4.24165 6.9531 4.13731 6.79687 4.06614 6.62493C3.99497 6.45299 3.95837 6.26872 3.95842 6.08263C3.95846 5.89654 3.99516 5.71229 4.06641 5.54039C4.13767 5.36848 4.24209 5.2123 4.3737 5.08075C4.50532 4.9492 4.66155 4.84486 4.83349 4.77369C5.00543 4.70252 5.1897 4.66592 5.37579 4.66596C5.75161 4.66606 6.11199 4.81544 6.37767 5.08125C6.64335 5.34706 6.79255 5.70752 6.79246 6.08334C6.79236 6.45916 6.64298 6.81954 6.37717 7.08522C6.11136 7.3509 5.7509 7.5001 5.37508 7.50001ZM9.62508 7.50001C9.439 7.49996 9.25474 7.46326 9.08284 7.39201C8.91094 7.32075 8.75475 7.21633 8.6232 7.08472C8.49165 6.9531 8.38731 6.79687 8.31614 6.62493C8.24497 6.45299 8.20837 6.26872 8.20842 6.08263C8.20846 5.89654 8.24516 5.71229 8.31642 5.54039C8.38767 5.36848 8.49209 5.2123 8.6237 5.08075C8.75532 4.9492 8.91155 4.84486 9.08349 4.77369C9.25543 4.70252 9.4397 4.66592 9.62579 4.66596C10.0016 4.66606 10.362 4.81544 10.6277 5.08125C10.8933 5.34706 11.0426 5.70752 11.0425 6.08334C11.0424 6.45916 10.893 6.81954 10.6272 7.08522C10.3614 7.3509 10.0009 7.5001 9.62508 7.50001Z"
        // fill="#EF3824"
      />
    </svg>
  );
};

const SvgCopy = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M3.95 5.64998C3.95 5.19911 4.1291 4.76671 4.44792 4.4479C4.76673 4.12909 5.19913 3.94998 5.65 3.94998H10.75C11.2009 3.94998 11.6333 4.12909 11.9521 4.4479C12.2709 4.76671 12.45 5.19911 12.45 5.64998V10.75C12.45 11.2009 12.2709 11.6333 11.9521 11.9521C11.6333 12.2709 11.2009 12.45 10.75 12.45H5.65C5.19913 12.45 4.76673 12.2709 4.44792 11.9521C4.1291 11.6333 3.95 11.2009 3.95 10.75V5.64998Z"
        fill="#F7951E"
      />
      <path
        d="M2.25 0.549988C1.79913 0.549988 1.36673 0.729094 1.04792 1.04791C0.72911 1.36672 0.550003 1.79912 0.550003 2.24999V7.34999C0.550003 7.80086 0.72911 8.23326 1.04792 8.55207C1.36673 8.87088 1.79913 9.04999 2.25 9.04999V2.24999H9.05C9.05 1.79912 8.8709 1.36672 8.55208 1.04791C8.23327 0.729094 7.80087 0.549988 7.35 0.549988H2.25Z"
        fill="#F7951E"
      />
    </svg>
  );
};

const SvgEraser = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.750001 5.45C0.56253 5.63753 0.457214 5.89183 0.457214 6.157C0.457214 6.42216 0.56253 6.67647 0.750001 6.864L2.679 8.793H1.043C0.910393 8.793 0.783216 8.84568 0.689447 8.93945C0.595679 9.03321 0.543001 9.16039 0.543001 9.293C0.543001 9.42561 0.595679 9.55278 0.689447 9.64655C0.783216 9.74032 0.910393 9.793 1.043 9.793H9.043C9.17561 9.793 9.30279 9.74032 9.39655 9.64655C9.49032 9.55278 9.543 9.42561 9.543 9.293C9.543 9.16039 9.49032 9.03321 9.39655 8.93945C9.30279 8.84568 9.17561 8.793 9.043 8.793H4.478L9.2355 4.0355C9.42297 3.84797 9.52829 3.59366 9.52829 3.3285C9.52829 3.06333 9.42297 2.80903 9.2355 2.6215L7.1135 0.499999C7.02064 0.407098 6.91038 0.333402 6.78903 0.283122C6.66768 0.232842 6.53761 0.206963 6.40625 0.206963C6.2749 0.206963 6.14483 0.232842 6.02347 0.283122C5.90212 0.333402 5.79186 0.407098 5.699 0.499999L0.750001 5.45ZM2.913 4.701L1.457 6.157L3.5785 8.278L5.034 6.8225L2.913 4.701ZM3.62 3.994L5.7415 6.115L8.528 3.3285L6.407 1.207L3.62 3.994Z"
        fill="white"
      />
    </svg>
  );
};

const SvgAccounting = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      {...props}
    >
      <path
        d="M1.41675 1.41666H2.83341V15.5833H1.41675V1.41666Z"
        fill="#383838"
      />
      <path
        d="M15.5834 2.83334V4.25001H1.41675V2.83334H15.5834Z"
        fill="#383838"
      />
      <path
        d="M14.1667 1.41666H15.5834V15.5833H14.1667V1.41666Z"
        fill="#383838"
      />
      <path
        d="M5.66667 4.95833C6.44907 4.95833 7.08333 4.32407 7.08333 3.54167C7.08333 2.75926 6.44907 2.125 5.66667 2.125C4.88426 2.125 4.25 2.75926 4.25 3.54167C4.25 4.32407 4.88426 4.95833 5.66667 4.95833Z"
        fill="#383838"
      />
      <path
        d="M15.5834 7.08334V8.50001H1.41675V7.08334H15.5834Z"
        fill="#383838"
      />
      <path
        d="M7.08341 9.20833C7.86582 9.20833 8.50008 8.57407 8.50008 7.79167C8.50008 7.00926 7.86582 6.375 7.08341 6.375C6.30101 6.375 5.66675 7.00926 5.66675 7.79167C5.66675 8.57407 6.30101 9.20833 7.08341 9.20833Z"
        fill="#383838"
      />
      <path
        d="M11.3334 9.20833C12.1158 9.20833 12.7501 8.57407 12.7501 7.79167C12.7501 7.00926 12.1158 6.375 11.3334 6.375C10.551 6.375 9.91675 7.00926 9.91675 7.79167C9.91675 8.57407 10.551 9.20833 11.3334 9.20833Z"
        fill="#383838"
      />
      <path
        d="M15.5833 11.3333V12.75H1.41667V11.3333H15.5833ZM17 14.875V16.2916H0V14.875H17Z"
        fill="#383838"
      />
      <path
        d="M5.66667 13.4583C6.44907 13.4583 7.08333 12.8241 7.08333 12.0417C7.08333 11.2593 6.44907 10.625 5.66667 10.625C4.88426 10.625 4.25 11.2593 4.25 12.0417C4.25 12.8241 4.88426 13.4583 5.66667 13.4583Z"
        fill="#383838"
      />
    </svg>
  );
};

const SvgIcon = (props) => {
  return (
    <svg
      id="Capa_1"
      enable-background="new 0 0 512.007 512.007"
      height="12"
      viewBox="0 0 512.007 512.007"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="m142 143.003h139v-143c-49.379 0-107.674 0-154 0v128c0 8.271 6.729 15 15 15z" />
        <path d="m345 128.003v-128c-9.97 0-21.461 0-34 0v143h19c8.271 0 15-6.729 15-15z" />
        <path d="m127 512.003h218v-161h-218z" />
        <path d="m511.927 126.537c-.279-2.828-1.38-5.667-3.315-8.027-.747-.913 6.893 6.786-114.006-114.113-2.882-2.882-6.794-4.396-10.612-4.394-.789 0-3.925 0-8.995 0v128c0 24.813-20.187 45-45 45-14.028 0-186.064 0-188 0-24.813 0-45-20.187-45-45v-128c-29.589 0-49.82 0-52 0-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h52c0-10.815 0-201.797 0-210 0-24.813 20.187-45 45-45h188c24.813 0 45 20.187 45 45v210h92c24.813 0 45-20.187 45-45 .001-364.186.041-339.316-.072-340.466z" />
        <path d="m330 287.003h-188c-8.271 0-15 6.729-15 15v19h218v-19c0-8.271-6.729-15-15-15z" />
      </g>
    </svg>
  );
};

export const IconCheck = (props) => (
  <FaCheck color="green" className="text-sm cursor-pointer" {...props} />
);
export const IconCancel = (props) => {
  return (
    <ImCancelCircle
      style={{
        width: 15,
        height: 15,
      }}
      color="#E61D01"
      {...props}
    />
  );
};

export const IconDiscount = (props) => (
  <SvgDiscount className="text-sm" {...props} />
);

const SvgDiscount = (props) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.07 13.43H6.36L4.69 11.71H2.22L1.69 11.21V8.79L0 7.07V6.36L1.69 4.64V2.21L2.22 1.71H4.69L6.36 0H7.07L8.79 1.71H11.22L11.72 2.2V4.64L13.43 6.36V7.07L11.69 8.79V11.21L11.19 11.71H8.79L7.07 13.43ZM5.42 9.19H6.13L9.9 5.42L9.19 4.71L5.78 8.13L4.4 6.75L3.69 7.46L5.42 9.19Z"
        fill="#DC3545"
      />
    </svg>
  );
};

export const IconService = (props) => (
  <SvgService className="text-sm" {...props} />
);

const SvgService = (props) => {
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.9686 7.35715C16.6144 7.03597 16.0621 7.05698 15.6899 7.35715L12.9163 9.57541C12.5771 9.84856 12.1539 9.99564 11.7156 9.99564H8.16462C7.90047 9.99564 7.68435 9.77952 7.68435 9.51537C7.68435 9.25122 7.90047 9.0351 8.16462 9.0351H10.515C10.9922 9.0351 11.4365 8.70792 11.5145 8.23665C11.6136 7.63631 11.1513 7.11401 10.566 7.11401H5.76326C4.9528 7.11401 4.16936 7.39317 3.539 7.90346L2.14321 9.0351H0.480272C0.216122 9.0351 0 9.25122 0 9.51537V12.397C0 12.6612 0.216122 12.8773 0.480272 12.8773H11.1903C11.6256 12.8773 12.0488 12.7302 12.391 12.457L16.9296 8.82498C17.3858 8.46178 17.4219 7.76538 16.9686 7.35715Z"
        fill="#F7941D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8923 0C11.1765 0 9.78552 1.39098 9.78552 3.10676C9.78552 4.82254 11.1765 6.21352 12.8923 6.21352C14.6081 6.21352 15.999 4.82254 15.999 3.10676C15.999 1.39098 14.6081 0 12.8923 0ZM14.2389 2.58143C14.2637 2.55309 14.2826 2.52007 14.2944 2.48432C14.3063 2.44858 14.3109 2.41082 14.3079 2.37328C14.305 2.33573 14.2945 2.29916 14.2772 2.26571C14.2599 2.23226 14.2361 2.20261 14.2072 2.1785C14.1782 2.15439 14.1448 2.13631 14.1087 2.12532C14.0727 2.11434 14.0349 2.11066 13.9974 2.11452C13.9599 2.11838 13.9236 2.1297 13.8906 2.1478C13.8576 2.1659 13.8285 2.19042 13.8051 2.21992L12.5906 3.67699L11.9622 3.04829C11.909 2.99685 11.8376 2.96838 11.7636 2.96902C11.6895 2.96967 11.6187 2.99937 11.5663 3.05174C11.5139 3.1041 11.4842 3.17494 11.4836 3.24899C11.483 3.32304 11.5114 3.39439 11.5629 3.44765L12.4102 4.29495C12.4379 4.32269 12.4711 4.34433 12.5077 4.35852C12.5443 4.3727 12.5834 4.3791 12.6226 4.37732C12.6618 4.37554 12.7002 4.36562 12.7354 4.34818C12.7705 4.33074 12.8016 4.30616 12.8268 4.27603L14.2389 2.58143Z"
        fill="#F7941D"
      />
    </svg>
  );
};

export const IconEye = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="10.5"
    viewBox="0 0 19 13"
    fill="none"
  >
    <path
      d="M9.50004 11.25C13.8724 11.25 17.4167 6.5 17.4167 6.5C17.4167 6.5 13.8724 1.75 9.50004 1.75C5.12767 1.75 1.58337 6.5 1.58337 6.5C1.58337 6.5 5.12767 11.25 9.50004 11.25Z"
      stroke="#F29302"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M9.50004 8.47909C10.0249 8.47909 10.5284 8.27057 10.8995 7.8994C11.2707 7.52823 11.4792 7.02483 11.4792 6.49992C11.4792 5.97501 11.2707 5.4716 10.8995 5.10044C10.5284 4.72927 10.0249 4.52075 9.50004 4.52075C8.97513 4.52075 8.47172 4.72927 8.10056 5.10044C7.72939 5.4716 7.52087 5.97501 7.52087 6.49992C7.52087 7.02483 7.72939 7.52823 8.10056 7.8994C8.47172 8.27057 8.97513 8.47909 9.50004 8.47909Z"
      stroke="#F29302"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconBack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="25"
    viewBox="0 0 15 25"
    fill="none"
    {...props}
  >
    <path
      d="M12.5112 24.9999C12.191 25.0008 11.8746 24.9419 11.5853 24.8276C11.296 24.7133 11.0411 24.5464 10.8394 24.3392L0.487562 13.626C0.17233 13.3065 0 12.9057 0 12.4921C0 12.0786 0.17233 11.6778 0.487562 11.3583L11.2038 0.645033C11.5676 0.280394 12.0903 0.0510867 12.6571 0.00755554C13.2238 -0.0359756 13.7881 0.109836 14.2257 0.412911C14.6634 0.715987 14.9387 1.1515 14.9909 1.62365C15.0432 2.09579 14.8682 2.56589 14.5044 2.93053L4.92407 12.5011L14.1829 22.0716C14.445 22.3337 14.6114 22.6528 14.6626 22.9913C14.7138 23.3297 14.6475 23.6733 14.4717 23.9814C14.2958 24.2894 14.0177 24.5491 13.6703 24.7296C13.3228 24.9101 12.9206 25.0039 12.5112 24.9999Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const IconGuideBuyer = () => (
  <svg
    className="mr-2"
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M12.036 0.778003C12.3848 0.684549 12.7487 0.660728 13.1068 0.707898C13.4648 0.755069 13.8101 0.872307 14.1228 1.05292C14.4356 1.23353 14.7097 1.47398 14.9295 1.76054C15.1493 2.04709 15.3106 2.37414 15.404 2.723L18.122 12.865C18.2154 13.2139 18.2393 13.5777 18.1921 13.9358C18.1449 14.2938 18.0277 14.6391 17.8471 14.9519C17.6665 15.2646 17.426 15.5387 17.1395 15.7585C16.8529 15.9784 16.5259 16.1396 16.177 16.233L9.89999 17.915C9.19558 18.1038 8.44503 18.005 7.81342 17.6405C7.18181 17.2759 6.72088 16.6754 6.53199 15.971L3.81299 5.828C3.71954 5.47915 3.69572 5.1153 3.74289 4.75723C3.79006 4.39917 3.9073 4.0539 4.08791 3.74115C4.26852 3.4284 4.50897 3.15429 4.79552 2.93447C5.08208 2.71465 5.40912 2.55342 5.75799 2.46L12.036 0.778003ZM3.80299 9.658L5.56499 16.229C5.73827 16.88 6.08451 17.4719 6.56699 17.942L6.12399 17.919C5.39573 17.8808 4.71248 17.5548 4.22452 17.0128C3.73656 16.4709 3.48386 15.7573 3.52199 15.029L3.80299 9.659V9.658ZM12.424 2.227L6.14599 3.909C5.98741 3.95148 5.83876 4.02477 5.70851 4.1247C5.57826 4.22463 5.46897 4.34923 5.38688 4.4914C5.30479 4.63357 5.25151 4.79052 5.23008 4.95328C5.20865 5.11604 5.2195 5.28143 5.26199 5.44L7.97899 15.582C8.02146 15.7406 8.09476 15.8892 8.19469 16.0195C8.29461 16.1497 8.41922 16.259 8.56139 16.3411C8.70356 16.4232 8.86051 16.4765 9.02327 16.4979C9.18603 16.5193 9.35142 16.5085 9.50999 16.466L15.789 14.784C15.9476 14.7415 16.0962 14.6682 16.2265 14.5683C16.3567 14.4684 16.466 14.3438 16.5481 14.2016C16.6302 14.0594 16.6835 13.9025 16.7049 13.7397C16.7263 13.577 16.7155 13.4116 16.673 13.253L13.955 3.111C13.8692 2.79096 13.6599 2.51808 13.373 2.35232C13.0861 2.18656 12.7451 2.14148 12.425 2.227H12.424ZM2.87799 8.18L2.52299 14.976C2.48599 15.675 2.64299 16.339 2.94699 16.916L2.53299 16.756C2.19581 16.6266 1.88742 16.432 1.62543 16.1835C1.36345 15.9349 1.15299 15.6371 1.00609 15.3072C0.859183 14.9772 0.778706 14.6216 0.769253 14.2606C0.759799 13.8995 0.821554 13.5402 0.950991 13.203L2.87799 8.18ZM7.74099 5.035C7.86904 4.99692 8.00342 4.98488 8.13621 4.99959C8.26899 5.01431 8.39747 5.05548 8.51408 5.12067C8.63068 5.18587 8.73304 5.27377 8.81511 5.37918C8.89719 5.48459 8.9573 5.60538 8.99192 5.73441C9.02653 5.86345 9.03494 5.99811 9.01664 6.13044C8.99835 6.26278 8.95373 6.39011 8.88541 6.50491C8.81709 6.61971 8.72646 6.71966 8.61887 6.79886C8.51128 6.87805 8.38891 6.93489 8.25899 6.966C8.00561 7.02669 7.73856 6.98609 7.51466 6.85285C7.29077 6.71961 7.12772 6.50425 7.06021 6.2526C6.99271 6.00096 7.02608 5.7329 7.15323 5.50549C7.28038 5.27808 7.49126 5.10928 7.74099 5.035Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const IconGuideTop5 = () => (
  <svg
    className="mr-2"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="23"
    viewBox="0 0 15 23"
    fill="none"
  >
    <path
      d="M7.49998 0.5625C6.07914 0.565699 4.69261 0.999281 3.52307 1.80611C2.35354 2.61295 1.45588 3.75517 0.948381 5.08229C0.44088 6.4094 0.347349 7.85913 0.680111 9.24046C1.01287 10.6218 1.75632 11.8699 2.81248 12.8203V22.4375L7.49998 19.3125L12.1875 22.4375V12.8203C13.2436 11.8699 13.9871 10.6218 14.3198 9.24046C14.6526 7.85913 14.5591 6.4094 14.0516 5.08229C13.5441 3.75517 12.6464 2.61295 11.4769 1.80611C10.3073 0.999281 8.92082 0.565699 7.49998 0.5625ZM10.625 19.5156L8.36717 18.0156L7.49998 17.4375L6.63279 18.0156L4.37498 19.5156V13.8828C5.34412 14.3718 6.41447 14.6265 7.49998 14.6265C8.58548 14.6265 9.65584 14.3718 10.625 13.8828V19.5156ZM11.3203 11.5C10.4168 12.3821 9.23585 12.9243 7.97798 13.0347C6.72011 13.1451 5.46281 12.8168 4.41949 12.1055C3.37617 11.3942 2.61113 10.3438 2.25423 9.13262C1.89733 7.9214 1.97056 6.624 2.4615 5.46064C2.95243 4.29729 3.83082 3.33966 4.94755 2.75032C6.06429 2.16098 7.35056 1.97624 8.58802 2.22746C9.82547 2.47868 10.9379 3.15038 11.7364 4.12854C12.5349 5.1067 12.9703 6.33105 12.9687 7.59375C12.9678 8.32181 12.8215 9.04235 12.5385 9.71313C12.2554 10.3839 11.8412 10.9914 11.3203 11.5Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const IconSticker = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      {...props}
    >
      <path
        d="M12.1042 0.416656H2.89591C1.55008 0.416656 0.416748 1.54999 0.416748 2.89582V12.1042C0.416748 13.45 1.55008 14.5833 2.89591 14.5833H10.3334L14.5834 10.3333V2.89582C14.5834 1.54999 13.4501 0.416656 12.1042 0.416656ZM9.62508 13.1667V12.1042C9.62508 10.7583 10.7584 9.62499 12.1042 9.62499H13.1667L9.62508 13.1667Z"
        fill="white"
      />
    </svg>
  );
};

export const IconChevronLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="25"
    viewBox="0 0 15 25"
    fill="none"
    {...props}
  >
    <path
      d="M12.5112 24.9999C12.191 25.0008 11.8746 24.9419 11.5853 24.8276C11.296 24.7133 11.0411 24.5464 10.8394 24.3392L0.487562 13.626C0.17233 13.3065 0 12.9057 0 12.4921C0 12.0786 0.17233 11.6778 0.487562 11.3583L11.2038 0.645033C11.5676 0.280394 12.0903 0.0510867 12.6571 0.00755554C13.2238 -0.0359756 13.7881 0.109836 14.2257 0.412911C14.6634 0.715987 14.9387 1.1515 14.9909 1.62365C15.0432 2.09579 14.8682 2.56589 14.5044 2.93053L4.92407 12.5011L14.1829 22.0716C14.445 22.3337 14.6114 22.6528 14.6626 22.9913C14.7138 23.3297 14.6475 23.6733 14.4717 23.9814C14.2958 24.2894 14.0177 24.5491 13.6703 24.7296C13.3228 24.9101 12.9206 25.0039 12.5112 24.9999Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const IconAlternativeProduct = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <rect width="20" height="20" rx="10" fill="#555580" />
    <path
      d="M12.108 14C12.036 14 11.988 13.968 11.964 13.904L11.484 12.392C11.476 12.368 11.46 12.356 11.436 12.356H7.848C7.824 12.356 7.808 12.368 7.8 12.392L7.32 13.904C7.296 13.968 7.248 14 7.176 14H6.528C6.44 14 6.408 13.956 6.432 13.868L9.084 5.696C9.108 5.632 9.156 5.6 9.228 5.6H10.044C10.116 5.6 10.164 5.632 10.188 5.696L12.852 13.868L12.864 13.916C12.864 13.972 12.828 14 12.756 14H12.108ZM8.04 11.6C8.032 11.616 8.032 11.632 8.04 11.648C8.056 11.656 8.072 11.66 8.088 11.66H11.184C11.2 11.66 11.212 11.656 11.22 11.648C11.236 11.632 11.24 11.616 11.232 11.6L9.672 6.704C9.664 6.688 9.652 6.68 9.636 6.68C9.62 6.68 9.608 6.688 9.6 6.704L8.04 11.6Z"
      fill="white"
    />
  </svg>
);

export const IconChevron = ({ up }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="10"
    viewBox="0 0 18 10"
    fill="none"
    className="cursor-pointer"
  >
    {up ? (
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M17 9L9 1L1 9"
        stroke="#BDBDBD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ) : (
      <path
        d="M1 1L9 9L17 1"
        stroke="#BDBDBD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

export const IconProductAnalog = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M8.25 14.2083H17.4167V2.29166"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 9.62499H4.58331V19.7083M20.1666 5.04166L17.4166 2.29166L14.6666 5.04166"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33331 16.9583L4.58331 19.7083L1.83331 16.9583"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconExclamationColored = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g filter="url(#filter0_d_80_378)">
      <circle cx="12" cy="9" r="8" fill="url(#paint0_linear_80_378)" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4C12.2652 4 12.5196 4.10536 12.7071 4.29289C12.8946 4.48043 13 4.73478 13 5V10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 10.8946 11.2929 10.7071C11.1054 10.5196 11 10.2652 11 10V5C11 4.73478 11.1054 4.48043 11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4ZM12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13C13 12.7348 12.8946 12.4804 12.7071 12.2929C12.5196 12.1054 12.2652 12 12 12C11.7348 12 11.4804 12.1054 11.2929 12.2929C11.1054 12.4804 11 12.7348 11 13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_80_378"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_80_378"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_80_378"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_80_378"
        x1="4"
        y1="-4.5"
        x2="25"
        y2="27"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE9C00" />
        <stop offset="1" stopColor="#E61D01" />
      </linearGradient>
    </defs>
  </svg>
);

export const IconImport = (props) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 7 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0C2.86333 0 1.89667 0.356667 1.51333 0.856667L3.26333 2.60667C3.5 2.64333 3.74 2.66667 4 2.66667C5.47333 2.66667 6.66667 2.07 6.66667 1.33333C6.66667 0.596667 5.47333 0 4 0ZM1.30667 1.36L0.833333 1.83333L1.66667 2.66667H0V3.33333H1.66667L0.833333 4.16667L1.30667 4.64L2.94667 3L1.30667 1.36ZM6.66667 2C6.66667 2.73667 5.47333 3.33333 4 3.33333C3.78 3.33333 3.56667 3.31667 3.36333 3.29L2.54 4.11333C2.96 4.25 3.46 4.33333 4 4.33333C5.47333 4.33333 6.66667 3.73667 6.66667 3V2ZM6.66667 3.66667C6.66667 4.40333 5.47333 5 4 5C3.24 5 2.55667 4.83333 2.07 4.58333L1.51 5.14333C1.89333 5.64333 2.86333 6 4 6C5.47333 6 6.66667 5.40333 6.66667 4.66667"
      fill="#f29302"
    />
  </svg>
);

export const IconExpand = (props) => (
  <GiExpand color="#BFBFBF" className="text-xl cursor-pointer" {...props} />
);

export const IconDuplicate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.6667 5.33333H9.33333V7.33333H7.33333V8.66667H9.33333V10.6667H10.6667V8.66667H12.6667V7.33333H10.6667V5.33333ZM1.33333 8C1.33333 6.14 2.42667 4.53333 4.00667 3.78667V2.34667C1.68 3.17333 0 5.39333 0 8C0 10.6067 1.68 12.8267 4.00667 13.6533V12.2133C3.2075 11.8367 2.53187 11.2406 2.05854 10.4946C1.58522 9.74865 1.33371 8.88348 1.33333 8ZM10 2C6.69333 2 4 4.69333 4 8C4 11.3067 6.69333 14 10 14C13.3067 14 16 11.3067 16 8C16 4.69333 13.3067 2 10 2ZM10 12.6667C7.42667 12.6667 5.33333 10.5733 5.33333 8C5.33333 5.42667 7.42667 3.33333 10 3.33333C12.5733 3.33333 14.6667 5.42667 14.6667 8C14.6667 10.5733 12.5733 12.6667 10 12.6667Z"
      fill="#FE9C00"
    />
  </svg>
);

export const IconNewProduct = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M11.8 7.12C11.8 7.08667 11.81 7.06 11.83 7.04C11.8567 7.01333 11.8867 7 11.92 7H12.84C12.8733 7 12.9 7.01333 12.92 7.04C12.9467 7.06 12.96 7.08667 12.96 7.12V13.88C12.96 13.9133 12.9467 13.9433 12.92 13.97C12.9 13.99 12.8733 14 12.84 14H11.95C11.8833 14 11.8367 13.9733 11.81 13.92L8.93 9.2C8.91667 9.18 8.90333 9.17333 8.89 9.18C8.87667 9.18 8.87 9.19333 8.87 9.22L8.89 13.88C8.89 13.9133 8.87667 13.9433 8.85 13.97C8.83 13.99 8.80333 14 8.77 14H7.85C7.81667 14 7.78667 13.99 7.76 13.97C7.74 13.9433 7.73 13.9133 7.73 13.88V7.12C7.73 7.08667 7.74 7.06 7.76 7.04C7.78667 7.01333 7.81667 7 7.85 7H8.74C8.80667 7 8.85333 7.02667 8.88 7.08L11.75 11.8C11.7633 11.82 11.7767 11.83 11.79 11.83C11.8033 11.8233 11.81 11.8067 11.81 11.78L11.8 7.12Z"
      fill="#555580"
      fillOpacity="0.6"
    />
    <path
      d="M10.5 18.9C8.83864 18.9 7.21459 18.4073 5.83321 17.4843C4.45184 16.5613 3.37519 15.2494 2.73942 13.7145C2.10364 12.1796 1.93729 10.4907 2.26141 8.86124C2.58552 7.2318 3.38555 5.73506 4.56031 4.5603C5.73507 3.38554 7.2318 2.58552 8.86125 2.2614C10.4907 1.93729 12.1796 2.10364 13.7145 2.73941C15.2494 3.37519 16.5613 4.45184 17.4843 5.83321C18.4073 7.21458 18.9 8.83863 18.9 10.5C18.9 12.7278 18.015 14.8644 16.4397 16.4397C14.8644 18.015 12.7278 18.9 10.5 18.9ZM10.5 0C8.4233 0 6.39323 0.615814 4.66652 1.76957C2.9398 2.92332 1.59399 4.5632 0.799269 6.48182C0.00454948 8.40044 -0.203386 10.5116 0.201759 12.5484C0.606904 14.5852 1.60693 16.4562 3.07538 17.9246C4.54383 19.3931 6.41476 20.3931 8.45156 20.7982C10.4884 21.2034 12.5996 20.9955 14.5182 20.2007C16.4368 19.406 18.0767 18.0602 19.2304 16.3335C20.3842 14.6068 21 12.5767 21 10.5C21 9.12112 20.7284 7.75574 20.2007 6.48182C19.6731 5.2079 18.8996 4.05039 17.9246 3.07538C16.9496 2.10036 15.7921 1.32694 14.5182 0.799265C13.2443 0.271591 11.8789 0 10.5 0Z"
      fill="#555580"
      fillOpacity="0.6"
    />
  </svg>
);

export const IconDotLine = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="76"
    viewBox="0 0 8 76"
    fill="none"
    style={{
      position: "absolute",
      left: "-11px",
      top: 60,
    }}
  >
    <path
      d="M1 1H0.5C0.5 0.723858 0.723857 0.5 1 0.5V1ZM1 72V72.5C0.723857 72.5 0.5 72.2761 0.5 72H1ZM7.35355 71.6464C7.54882 71.8417 7.54882 72.1583 7.35355 72.3536L4.17157 75.5355C3.97631 75.7308 3.65973 75.7308 3.46447 75.5355C3.2692 75.3403 3.2692 75.0237 3.46447 74.8284L6.29289 72L3.46447 69.1716C3.2692 68.9763 3.2692 68.6597 3.46447 68.4645C3.65973 68.2692 3.97631 68.2692 4.17157 68.4645L7.35355 71.6464ZM7 1.5H6.25V0.5H7V1.5ZM4.75 1.5H3.25V0.5H4.75V1.5ZM1.75 1.5H1V0.5H1.75V1.5ZM1.5 1V1.98611H0.5V1H1.5ZM1.5 3.95833V5.93056H0.5V3.95833H1.5ZM1.5 7.90278V9.875H0.5V7.90278H1.5ZM1.5 11.8472V13.8194H0.5V11.8472H1.5ZM1.5 15.7917V17.7639H0.5V15.7917H1.5ZM1.5 19.7361V21.7083H0.5V19.7361H1.5ZM1.5 23.6806V25.6528H0.5V23.6806H1.5ZM1.5 27.625V29.5972H0.5V27.625H1.5ZM1.5 31.5694V33.5417H0.5V31.5694H1.5ZM1.5 35.5139V37.4861H0.5V35.5139H1.5ZM1.5 39.4583V41.4305H0.5V39.4583H1.5ZM1.5 43.4028V45.375H0.5V43.4028H1.5ZM1.5 47.3472V49.3194H0.5V47.3472H1.5ZM1.5 51.2917V53.2639H0.5V51.2917H1.5ZM1.5 55.2361V57.2083H0.5V55.2361H1.5ZM1.5 59.1805V61.1528H0.5V59.1805H1.5ZM1.5 63.125V65.0972H0.5V63.125H1.5ZM1.5 67.0694V69.0416H0.5V67.0694H1.5ZM1.5 71.0139V72H0.5V71.0139H1.5ZM1 71.5H1.75V72.5H1V71.5ZM3.25 71.5H4.75V72.5H3.25V71.5ZM6.25 71.5H7V72.5H6.25V71.5Z"
      fill="#555580"
    />
  </svg>
);

export const IconAlert = () => (
  <svg
    className="mr-2"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <g clipPath="url(#clip0_9_795)">
      <path
        d="M11 0C4.92545 0 0 4.92545 0 11C0 17.0746 4.92545 22 11 22C17.0746 22 22 17.0746 22 11C22 4.92545 17.0746 0 11 0ZM11 20.1339C5.9567 20.1339 1.86607 16.0433 1.86607 11C1.86607 5.9567 5.9567 1.86607 11 1.86607C16.0433 1.86607 20.1339 5.9567 20.1339 11C20.1339 16.0433 16.0433 20.1339 11 20.1339Z"
        fill="#FFC53D"
      />
      <path
        d="M9.82104 15.3214C9.82104 15.634 9.94522 15.9338 10.1662 16.1548C10.3873 16.3758 10.687 16.5 10.9996 16.5C11.3122 16.5 11.612 16.3758 11.833 16.1548C12.054 15.9338 12.1782 15.634 12.1782 15.3214C12.1782 15.0089 12.054 14.7091 11.833 14.4881C11.612 14.267 11.3122 14.1429 10.9996 14.1429C10.687 14.1429 10.3873 14.267 10.1662 14.4881C9.94522 14.7091 9.82104 15.0089 9.82104 15.3214V15.3214ZM10.4103 12.5714H11.5889C11.6969 12.5714 11.7853 12.483 11.7853 12.375V5.69643C11.7853 5.58839 11.6969 5.5 11.5889 5.5H10.4103C10.3023 5.5 10.2139 5.58839 10.2139 5.69643V12.375C10.2139 12.483 10.3023 12.5714 10.4103 12.5714Z"
        fill="#FFC53D"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_795">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconEnergyLabel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1_22)">
      <path
        d="M9.10416 13.4584C8.7611 13.4584 8.42807 13.4122 8.10507 13.3198C7.78155 13.2275 7.48124 13.0889 7.20416 12.9042L6.88749 13.2209C6.72916 13.3792 6.54444 13.4584 6.33332 13.4584C6.12221 13.4584 5.93749 13.3792 5.77916 13.2209C5.62082 13.0625 5.54166 12.8778 5.54166 12.6667C5.54166 12.4556 5.62082 12.2709 5.77916 12.1125L6.09582 11.7959C5.9111 11.5188 5.77256 11.2185 5.6802 10.8949C5.58784 10.5719 5.54166 10.2389 5.54166 9.89585C5.54166 8.86669 5.89791 8.01565 6.61041 7.34273C7.32291 6.66981 8.15416 6.33335 9.10416 6.33335H12.6667V9.89585C12.6667 10.8854 12.3204 11.7267 11.628 12.4197C10.935 13.1121 10.0937 13.4584 9.10416 13.4584ZM9.10416 11.875C9.65832 11.875 10.1267 11.6837 10.5094 11.3011C10.892 10.9184 11.0833 10.45 11.0833 9.89585V7.91669H9.10416C8.57638 7.91669 8.11457 8.10458 7.71874 8.48035C7.32291 8.85666 7.12499 9.32849 7.12499 9.89585C7.12499 10.0278 7.13819 10.1531 7.16457 10.2719C7.19096 10.3906 7.22395 10.5028 7.26353 10.6084L8.94582 8.94585C9.10416 8.78752 9.28888 8.70835 9.49999 8.70835C9.7111 8.70835 9.89582 8.78752 10.0542 8.94585C10.2125 9.10419 10.2917 9.28891 10.2917 9.50002C10.2917 9.71113 10.2125 9.89585 10.0542 10.0542L8.39166 11.7365C8.49721 11.7761 8.60937 11.809 8.72812 11.8354C8.84687 11.8618 8.97221 11.875 9.10416 11.875ZM9.49999 18.2084L6.76874 16.0709L3.34478 15.6552L2.92916 12.2313L0.791656 9.50002L2.92916 6.76877L3.34478 3.34481L6.76874 2.92919L9.49999 0.791687L12.2312 2.92919L15.6552 3.34481L16.0708 6.76877L18.2083 9.50002L16.0708 12.2313L15.6552 15.6552L12.2312 16.0709L9.49999 18.2084ZM9.49999 16.1896L11.5979 14.5667L14.25 14.2302L14.5667 11.5979L16.1896 9.50002L14.5667 7.4021L14.2302 4.76981L11.5979 4.43335L9.49999 2.81044L7.40207 4.43335L4.74999 4.76981L4.43332 7.4021L2.81041 9.50002L4.43332 11.5979L4.76978 14.25L7.40207 14.5667L9.49999 16.1896Z"
        fill="black"
        stroke="white"
        strokeWidth="0.4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_22">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconDelete = (props) => (
  <MdDelete className="text-sm" {...props} />
);
export const IconPlus = () => (
  <AiOutlinePlus className="text-base text-orange cursor-pointer" />
);

export const IconPDF = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      d="M3.19999 7.30001C3.09391 7.30001 2.99217 7.34215 2.91715 7.41716C2.84214 7.49218 2.79999 7.59392 2.79999 7.70001V9.30001C2.79999 9.40609 2.84214 9.50783 2.91715 9.58285C2.99217 9.65786 3.09391 9.70001 3.19999 9.70001C3.30608 9.70001 3.40782 9.65786 3.48284 9.58285C3.55785 9.50783 3.59999 9.40609 3.59999 9.30001V9.16721H3.86639C4.114 9.16721 4.35146 9.06884 4.52655 8.89376C4.70163 8.71868 4.79999 8.48121 4.79999 8.23361C4.79999 7.986 4.70163 7.74854 4.52655 7.57345C4.35146 7.39837 4.114 7.30001 3.86639 7.30001H3.19999ZM3.86639 8.36721H3.59999V8.10001H3.86639C3.90183 8.10001 3.93581 8.11408 3.96086 8.13914C3.98592 8.16419 3.99999 8.19817 3.99999 8.23361C3.99999 8.26904 3.98592 8.30302 3.96086 8.32808C3.93581 8.35313 3.90183 8.36721 3.86639 8.36721ZM7.59999 7.69921C7.60021 7.59326 7.64244 7.49172 7.71743 7.41688C7.79243 7.34204 7.89405 7.30001 7.99999 7.30001H8.79919C8.90528 7.30001 9.00702 7.34215 9.08204 7.41716C9.15705 7.49218 9.19919 7.59392 9.19919 7.70001C9.19919 7.80609 9.15705 7.90783 9.08204 7.98285C9.00702 8.05786 8.90528 8.10001 8.79919 8.10001H8.39919V8.36801H8.79919C8.90528 8.36801 9.00702 8.41015 9.08204 8.48516C9.15705 8.56018 9.19919 8.66192 9.19919 8.76801C9.19919 8.87409 9.15705 8.97583 9.08204 9.05085C9.00702 9.12586 8.90528 9.16801 8.79919 9.16801H8.39919L8.39999 9.29921C8.4001 9.35174 8.38986 9.40377 8.36985 9.45234C8.34985 9.50091 8.32047 9.54507 8.2834 9.58228C8.20854 9.65745 8.10688 9.69979 8.00079 9.70001C7.89471 9.70022 7.79288 9.65828 7.71772 9.58342C7.64255 9.50855 7.60021 9.40689 7.59999 9.30081V7.69921ZM5.59839 7.30001C5.49231 7.30001 5.39057 7.34215 5.31555 7.41716C5.24054 7.49218 5.19839 7.59392 5.19839 7.70001V9.30001C5.19839 9.40609 5.24054 9.50783 5.31555 9.58285C5.39057 9.65786 5.49231 9.70001 5.59839 9.70001H5.99999C6.31825 9.70001 6.62348 9.57358 6.84852 9.34853C7.07357 9.12349 7.19999 8.81827 7.19999 8.50001C7.19999 8.18175 7.07357 7.87652 6.84852 7.65148C6.62348 7.42643 6.31825 7.30001 5.99999 7.30001H5.59839ZM5.99839 8.90001V8.10001H5.99999C6.10608 8.10001 6.20782 8.14215 6.28284 8.21716C6.35785 8.29218 6.39999 8.39392 6.39999 8.50001C6.39999 8.60609 6.35785 8.70783 6.28284 8.78285C6.20782 8.85786 6.10608 8.90001 5.99999 8.90001H5.99839ZM1.19999 1.70001C1.19999 1.27566 1.36856 0.868693 1.66862 0.568635C1.96868 0.268577 2.37565 0.100006 2.79999 0.100006H6.46799C6.62566 0.10004 6.78178 0.131145 6.92742 0.191543C7.07306 0.251941 7.20537 0.340448 7.31679 0.452006L10.448 3.58321C10.6731 3.80803 10.7997 4.11305 10.8 4.43121V5.76561C11.0336 5.84858 11.2358 6.00188 11.3788 6.20444C11.5218 6.407 11.5985 6.64888 11.5984 6.89681V10.0992C11.5985 10.3471 11.5218 10.589 11.3788 10.7916C11.2358 10.9941 11.0336 11.1474 10.8 11.2304V11.3C10.8 11.7244 10.6314 12.1313 10.3314 12.4314C10.0313 12.7314 9.62434 12.9 9.19999 12.9H2.79999C2.37565 12.9 1.96868 12.7314 1.66862 12.4314C1.36856 12.1313 1.19999 11.7244 1.19999 11.3V11.2304C0.966189 11.1477 0.763736 10.9947 0.620478 10.7923C0.47722 10.5898 0.400195 10.348 0.399994 10.1V6.89761C0.399864 6.64935 0.476736 6.40716 0.620016 6.20441C0.763297 6.00167 0.965932 5.84836 1.19999 5.76561V1.70001ZM9.99999 4.90001H7.19999C6.88173 4.90001 6.57651 4.77358 6.35147 4.54853C6.12642 4.32349 5.99999 4.01827 5.99999 3.70001V0.900006H2.79999C2.58782 0.900006 2.38434 0.984292 2.23431 1.13432C2.08428 1.28435 1.99999 1.48783 1.99999 1.70001V5.69681H9.99999V4.90001ZM1.99999 11.2992C1.99989 11.4043 2.0205 11.5084 2.06066 11.6056C2.10082 11.7028 2.15973 11.791 2.23403 11.8654C2.30832 11.9398 2.39655 11.9988 2.49366 12.039C2.59078 12.0793 2.69487 12.1 2.79999 12.1H9.19999C9.30512 12.1 9.40921 12.0793 9.50633 12.039C9.60344 11.9988 9.69166 11.9398 9.76596 11.8654C9.84026 11.791 9.89917 11.7028 9.93933 11.6056C9.97948 11.5084 10.0001 11.4043 9.99999 11.2992H1.99999ZM6.79999 1.06561V3.70001C6.79999 3.80609 6.84214 3.90783 6.91715 3.98285C6.99217 4.05786 7.09391 4.10001 7.19999 4.10001H9.83439L6.79999 1.06561ZM1.59999 6.49681C1.49391 6.49681 1.39217 6.53895 1.31715 6.61396C1.24214 6.68898 1.19999 6.79072 1.19999 6.89681V10.0992C1.19999 10.2053 1.24214 10.307 1.31715 10.382C1.39217 10.4571 1.49391 10.4992 1.59999 10.4992H10.3976C10.5037 10.4992 10.6054 10.4571 10.6804 10.382C10.7555 10.307 10.7976 10.2053 10.7976 10.0992V6.89681C10.7976 6.79072 10.7555 6.68898 10.6804 6.61396C10.6054 6.53895 10.5037 6.49681 10.3976 6.49681H1.59999Z"
      fill="#777777"
    />
  </svg>
);

export const IconClear = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
  >
    <path
      fillrule="evenodd"
      cliprule="evenodd"
      d="M0.704271 7.62299C0.444695 7.88265 0.298874 8.23477 0.298874 8.60192C0.298874 8.96907 0.444695 9.32119 0.704271 9.58084L3.37519 12.2518H1.10996C0.926351 12.2518 0.75026 12.3247 0.620427 12.4545C0.490594 12.5844 0.417655 12.7605 0.417655 12.9441C0.417655 13.1277 0.490594 13.3038 0.620427 13.4336C0.75026 13.5634 0.926351 13.6364 1.10996 13.6364H12.1869C12.3705 13.6364 12.5466 13.5634 12.6764 13.4336C12.8063 13.3038 12.8792 13.1277 12.8792 12.9441C12.8792 12.7605 12.8063 12.5844 12.6764 12.4545C12.5466 12.3247 12.3705 12.2518 12.1869 12.2518H5.86612L12.4534 5.66445C12.713 5.4048 12.8588 5.05268 12.8588 4.68553C12.8588 4.31838 12.713 3.96626 12.4534 3.70661L9.51527 0.769146C9.38669 0.640513 9.23403 0.538473 9.066 0.468855C8.89797 0.399236 8.71788 0.363403 8.536 0.363403C8.35412 0.363403 8.17403 0.399236 8.006 0.468855C7.83798 0.538473 7.68531 0.640513 7.55673 0.769146L0.704271 7.62299ZM3.69919 6.58592L1.68319 8.60192L4.62066 11.5387L6.63596 9.52338L3.69919 6.58592ZM4.67812 5.60699L7.61558 8.54376L11.4738 4.68553L8.53704 1.74807L4.67812 5.60699Z"
      fill="white"
    />
  </svg>
);

export const IconTrRequestDispatch = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.72998" width="16" height="16" rx="8" fill="#E8E8E8" />
      <rect x="0.72998" width="16" height="16" rx="8" fill="black" />
      <path
        d="M8.47604 12C8.40937 12 8.37604 11.9667 8.37604 11.9V5.1C8.37604 5.03333 8.40937 5 8.47604 5H8.98604C9.0527 5 9.08604 5.03333 9.08604 5.1V11.9C9.08604 11.9667 9.0527 12 8.98604 12H8.47604Z"
        fill="white"
      />
    </svg>
  );
};

export const IconTrRequestWithdrawal = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.72998"
        y="0.710022"
        width="16"
        height="16"
        rx="8"
        fill="#E8E8E8"
      />
      <path
        d="M10.7829 12.71C10.7229 12.71 10.6829 12.6834 10.6629 12.63L10.2629 11.37C10.2562 11.35 10.2429 11.34 10.2229 11.34H7.23287C7.21287 11.34 7.19954 11.35 7.19287 11.37L6.79287 12.63C6.77287 12.6834 6.73287 12.71 6.67287 12.71H6.13287C6.05954 12.71 6.03287 12.6734 6.05287 12.6L8.26287 5.79002C8.28287 5.73669 8.32287 5.71002 8.38287 5.71002H9.06287C9.12287 5.71002 9.16287 5.73669 9.18287 5.79002L11.4029 12.6L11.4129 12.64C11.4129 12.6867 11.3829 12.71 11.3229 12.71H10.7829ZM7.39287 10.71C7.3862 10.7234 7.3862 10.7367 7.39287 10.75C7.4062 10.7567 7.41954 10.76 7.43287 10.76H10.0129C10.0262 10.76 10.0362 10.7567 10.0429 10.75C10.0562 10.7367 10.0595 10.7234 10.0529 10.71L8.75287 6.63002C8.7462 6.61669 8.7362 6.61002 8.72287 6.61002C8.70954 6.61002 8.69954 6.61669 8.69287 6.63002L7.39287 10.71Z"
        fill="#212121"
      />
    </svg>
  );
};
